// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const MCP_PHASE_1_TOOLS = [
    'search_regulatory',
    'search_documents',
    'read_document',
    'search_module',
    'detect_framework_conflicts',
    'search_workflows',
];
export const MCP_PHASE_2_WRITE_TOOLS = [
    'create_task',
    'bulk_create_tasks',
    'attach_evidence',
    'propose_edit',
    'generate_docx',
    'convert_chat_to_workflow_run',
];
export const MCP_PHASE_2_MEMORY_TOOLS = [
    'get_org_memory_by_anchor',
    'search_org_memories',
];
export const MCP_PHASE_2_SUBAGENT_TOOLS = [
    'suggest_persona_handoff',
];
export const MCP_ALL_TOOLS = [
    ...MCP_PHASE_1_TOOLS,
    ...MCP_PHASE_2_WRITE_TOOLS,
    ...MCP_PHASE_2_MEMORY_TOOLS,
    ...MCP_PHASE_2_SUBAGENT_TOOLS,
];
//# sourceMappingURL=mcp.js.map